module.exports = __webpack_public_path__ + "img/logo.a17eed61.png";